/* eslint-disable jsx-a11y/no-static-element-interactions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import React, { useState } from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import { pushEventInfo } from '../../../utils/analytics';
import SubscriptionCheckbox from '../order-subscription/SubscriptionCheckbox';
import BuyItAgainErrorAlert from './BuyItAgainErrorAlert';
import '../../../styles/order-details.scss';
export default function BuyItAgainButton(_a) {
    var fulfillmentLocation = _a.fulfillmentLocation, fulfillmentType = _a.fulfillmentType, _b = _a.isSubscriptionEligible, isSubscriptionEligible = _b === void 0 ? false : _b, itemId = _a.itemId, quantity = _a.quantity, applianceStoreId = _a.applianceStoreId, _c = _a.subscriptionDefaultFrequency, subscriptionDefaultFrequency = _c === void 0 ? '' : _c;
    var _d = useState(false), addToCartError = _d[0], setAddToCartError = _d[1];
    var _e = useState(false), subscriptionChecked = _e[0], setSubscriptionChecked = _e[1];
    var handleSubscriptionChange = function () {
        return setSubscriptionChecked(!subscriptionChecked);
    };
    var isMobile = useCommonContext().isMobile;
    // AddToCart request itemId must always be a string.
    var formattedItemId = itemId && typeof itemId === 'string' ? itemId : itemId === null || itemId === void 0 ? void 0 : itemId.toString();
    var addToCartReqs = __assign(__assign({ itemId: formattedItemId, quantity: "".concat(quantity), fulfillmentLocation: fulfillmentLocation, fulfillmentMethod: fulfillmentType, applianceDeliveryStore: applianceStoreId }, (subscriptionChecked && {
        subscriptions: { frequency: subscriptionDefaultFrequency },
    })), { isSubscribeAndSaveOpted: subscriptionChecked });
    var getCartHost = function () {
        if (typeof window !== 'undefined') {
            var origin_1 = window.location.origin;
            return origin_1.includes('local') ? 'https://www.homedepot.com' : origin_1;
        }
        return 'https://www.homedepot.com';
    };
    var cartOptions = {
        host: getCartHost(),
        channel: isMobile ? 'mobile' : 'desktop',
        paypal: false,
        misship: false,
    };
    var handleCartFail = function () {
        setAddToCartError(true);
    };
    var buttonClick = function () {
        // Analytics
        pushEventInfo({
            category: { primaryCategory: 'button submission' },
            eventInfo: { eventName: 'my account settings: Buy Again' },
            myAccount: { settings: 'purchase details: Buy Again button' },
        });
    };
    return (React.createElement(React.Fragment, null,
        addToCartError && React.createElement(BuyItAgainErrorAlert, null),
        isSubscriptionEligible && (React.createElement(SubscriptionCheckbox, { subscriptionChecked: subscriptionChecked, handleSubscriptionChange: handleSubscriptionChange })),
        React.createElement("div", { className: "card-fix", onClick: buttonClick },
            React.createElement(AddToCart, { className: "card-fix", cartReqParams: addToCartReqs, cartOptions: cartOptions, onFail: handleCartFail, variant: "secondary", outline: true, fullWidth: true }, subscriptionChecked ? 'Subscribe' : 'Buy Again'))));
}
